// trailingParagraphPlugin.js
// Plugin to ensure there's always an empty paragraph at the end of the document

import {Plugin} from 'prosemirror-state';

/**
 * Returns true when the transaction originated from y-prosemirror (remote sync or undo).
 * Matches the same set of meta keys used by blockIdPlugin.
 */
function isYjsTransaction(tr) {
    return (
        tr.getMeta("y-sync") != null ||
        tr.getMeta("yjs") != null ||
        tr.getMeta("y-undo") != null ||
        tr.getMeta("y-reset") != null ||
        tr.getMeta("y-sync$") != null
    );
}

/**
 * Plugin that ensures there's always an empty paragraph at the end of the document
 * This improves UX by always giving users a place to click and continue typing
 */
export function trailingParagraphPlugin() {
    return new Plugin({
        appendTransaction(transactions, oldState, newState) {
            // Skip if no document changes
            const docChanged = transactions.some(tr => tr.docChanged);
            if (!docChanged) return null;

            // Skip Yjs remote transactions — appending a local PM step here would
            // create an orphan step that y-prosemirror cannot reconcile with the Yjs doc.
            if (transactions.some(isYjsTransaction)) return null;

            const {doc} = newState;
            const lastNode = doc.lastChild;

            // Check if last node is an empty paragraph
            const needsTrailingParagraph = !lastNode ||
                lastNode.type.name !== 'paragraph' ||
                lastNode.content.size > 0;

            if (needsTrailingParagraph) {
                const tr = newState.tr;
                const paragraphType = newState.schema.nodes.paragraph;

                // Append empty paragraph at the end
                tr.insert(doc.content.size, paragraphType.create());

                return tr;
            }

            return null;
        }
    });
}

